import React, { FC } from 'react';

import { timelineContainer, timelineItem } from './styles.css';

export const TimelineContainer: FC = ({ children }) => <ul className={timelineContainer}>{children}</ul>;

export const TimelineItem: FC = ({ children }) => <li className={timelineItem}>{children}</li>;
